import React from "react";
import "./ShadowTechniqueHelp.css";

const ShadowTechniqueHelp = ({ onClose }) => {
  return (
    <div className="shadow-help-overlay" onClick={onClose}>
      <div className="shadow-help-box" onClick={(e) => e.stopPropagation()}>
        <div className="shadow-help-header">
          <div className="shadow-help-title">
            <span className="shadow-help-icon">🎯</span>
            <h3>راهنمای تکنیک سایه</h3>
          </div>
          <button className="shadow-help-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="shadow-help-content">
          <div className="shadow-help-section">
            <h4>تکنیک سایه (Shadowing) برای یادگیری زبان</h4>
            <p>
              این تکنیک به شما کمک میکنه با تکرار هوشمند، تلفظ و لهجه خودتون رو
              بهبود بدید. با این روش می‌تونید مثل یک سایه، همزمان با گوینده صحبت
              کنید!
            </p>
          </div>

          <div className="shadow-help-section">
            <h4>مراحل استفاده:</h4>
            <div className="shadow-help-steps">
              <div className="shadow-help-step">
                <span className="step-number">①</span>
                <span>کادر فرآیند رو از تنظیمات فعال کنید</span>
              </div>
              <div className="shadow-help-step">
                <span className="step-number">②</span>
                <span>روی دکمه "شروع" کلیک کنید تا زمان شروع جمله ثبت بشه</span>
              </div>
              <div className="shadow-help-step">
                <span className="step-number">③</span>
                <span>
                  روی دکمه "پایان" کلیک کنید تا زمان پایان جمله ثبت بشه
                </span>
              </div>
              <div className="shadow-help-step">
                <span className="step-number">④</span>
                <span>تعداد تکرار و تنظیمات هر تکرار رو مشخص کنید</span>
              </div>
              <div className="shadow-help-step">
                <span className="step-number">⑤</span>
                <span>
                  دکمه "شروع تکنیک سایه" رو بزنید و همزمان با فیلم تکرار کنید!
                </span>
              </div>
            </div>
          </div>

          <div className="shadow-help-section">
            <h4>تنظیمات پیشرفته هر تکرار:</h4>
            <div className="shadow-help-settings-grid">
              <div className="shadow-help-setting-item">
                <span className="setting-icon">🔊</span>
                <span className="setting-label">ولوم صدا:</span>
                <span className="setting-desc">
                  کنترل میزان صدا در هر تکرار
                </span>
              </div>
              <div className="shadow-help-setting-item">
                <span className="setting-icon">⏱️</span>
                <span className="setting-label">سرعت پخش:</span>
                <span className="setting-desc">
                  از ۰.۵x (آهسته) تا ۳x (تند)
                </span>
              </div>
              <div className="shadow-help-setting-item">
                <span className="setting-icon">👁️</span>
                <span className="setting-label">نمایش:</span>
                <span className="setting-desc">
                  زیرنویس کامل نمایش داده میشه
                </span>
              </div>
              <div className="shadow-help-setting-item">
                <span className="setting-icon">🙈</span>
                <span className="setting-label">پنهان:</span>
                <span className="setting-desc">زیرنویس دیده نمیشه</span>
              </div>
              <div className="shadow-help-setting-item">
                <span className="setting-icon">🕵️</span>
                <span className="setting-label">زیر کاور:</span>
                <span className="setting-desc">
                  زیرنویس کمرنگه و با هاور کامل میشه
                </span>
              </div>
            </div>
          </div>

          <div className="shadow-help-section">
            <h4>💡 نکات مهم:</h4>
            <ul className="shadow-help-tips">
              <li>هر تکرار می‌تونه تنظیمات متفاوتی داشته باشه</li>
              <li>مثلاً: اول آهسته با زیرنویس، بعد تندتر بدون زیرنویس</li>
              <li>
                هدف نهایی اینه که بدون دیدن زیرنویس و با سرعت عادی بتونید همزمان
                صحبت کنید
              </li>
              <li>
                با کلیک روی دکمه "شروع" و "پایان" در هر لحظه از فیلم، زمان‌ها
                به‌روز میشن
              </li>
            </ul>
          </div>

          <div className="shadow-help-footer">
            <button className="shadow-help-got-it" onClick={onClose}>
              متوجه شدم 👍
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShadowTechniqueHelp;
